import React, { useState, useEffect, useRef } from "react";
import Tile from "./Tile";
import Cell from "./Cell";
import { Board } from "../../helper/2048";
import useEvent from "../../hooks/2048/useEvent";
import GameOverlay from "./GameOverlay";
import { connect } from "react-redux";
import * as actions from "../../../actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowDown
} from "@fortawesome/free-solid-svg-icons";
import "../../stylesheet/2048-main.scss";
import "../../stylesheet/2048-styles.scss";

const BoardView = (props) => {
  
  const [board, setBoard] = useState(new Board());

  useEffect(() => {
    props.fetch2048GamesScores();
  }, []);

  const renderHighScore = () => {
    const { data } = props;
    const scores = _.orderBy(data, ['score', 'createAt'], ['desc', 'asc']);
    if (scores.length !== 0 && scores[0].score > board.score) {
      return(<div>{scores[0].score}</div>);
    } else {
      return(<div>{board.score}</div>);
    }
  }

  const handleKeyDown = (event) => {
    if (board.hasWon()) {
      return;
    }

    if (event.keyCode >= 37 && event.keyCode <= 40) {
      let direction = event.keyCode - 37;
      let boardClone = Object.assign(
        Object.create(Object.getPrototypeOf(board)),
        board
      );
      let newBoard = boardClone.move(direction);
      setBoard(newBoard);
    }
  };

  const handleButtonClick = (keyCode) => {
    if (board.hasWon()) {
      return;
    }

    if (keyCode >= 37 && keyCode <= 40) {
      let direction = keyCode - 37;
      let boardClone = Object.assign(
        Object.create(Object.getPrototypeOf(board)),
        board
      );
      let newBoard = boardClone.move(direction);
      setBoard(newBoard);
    }
  };

  useEvent("keydown", handleKeyDown);

  const cells = board.cells.map((row, rowIndex) => {
    return (
      <div key={rowIndex}>
        {row.map((col, colIndex) => {
          return <Cell key={rowIndex * board.size + colIndex} />;
        })}
      </div>
    );
  });

  const tiles = board.tiles
    .filter((tile) => tile.value !== 0)
    .map((tile, index) => {
      return <Tile tile={tile} key={index} />;
    });

  const resetGame = () => {
    setBoard(new Board());
  };

  return (
    <div className="game-2048-body">
      <h1 className="game-2048-text">2048</h1>
      <div className="game-2048-details-box">
        <div className="game-2048-resetButton" onClick={resetGame}>
          New Game
        </div>
        <div className="game-2048-score-box">
          <div className="game-2048-score-header">HIGHSCORE</div>
          {renderHighScore()}
        </div>
        <div className="game-2048-score-box">
          <div className="game-2048-score-header">SCORES</div>
          <div>{board.score}</div>
        </div>
      </div>
      <div className="game-2048-board">
        {cells}
        {tiles}
        <GameOverlay onRestart={resetGame} board={board} props={props}/>
      </div>
      { window.innerWidth <= 800 ?
        <div className="game-2048-controller">
          <button onClick={() => handleButtonClick(37)}><FontAwesomeIcon icon={faArrowLeft} size="1x" /></button>
          <button onClick={() => handleButtonClick(39)}><FontAwesomeIcon icon={faArrowRight} size="1x" /></button>
          <button onClick={() => handleButtonClick(38)}><FontAwesomeIcon icon={faArrowUp} size="1x" /></button>
          <button onClick={() => handleButtonClick(40)}><FontAwesomeIcon icon={faArrowDown} size="1x" /></button>
        </div> : null
      }
    </div>
  );
};

const mapStateToProps = ({ data }) => {
  return {
      data,
  };
};

export default connect(mapStateToProps, actions)(BoardView);